// import React, { useEffect, useState } from "react";
// import { Formik, Form, Field, ErrorMessage } from "formik";
// import * as Yup from "yup";
// import './CandidatesPage.css';
// import { getCandidateList } from "./Service/RecruitmentService";
// import { Link } from "react-router-dom/cjs/react-router-dom.min";

// const FALLBACK_CANDIDATES = [
//   {
//     name: "Rahul Kumar",
//     initials: "RK",
//     color: "#6366f1",
//     role: "Senior Frontend Developer",
//     exp: "5 yrs",
//     location: "Delhi",
//     salary: "14–18 LPA",
//     days: "30d",
//     source: "ATS",
//     sourceLabel: "ATS",
//     stage: "Interview",
//     skills: ["React", "TypeScript", "Next.js", "Redux"],
//     lastNote: { text: '"Strong React. Confident communicator. Proceed to HR round."', by: "Rahul Dev", when: "3d ago" },
//     job: "JOB-2026-001",
//     interviewStatus: { label: "R2 Scheduled · Today", bg: "#fff7ed", color: "#c2410c" },
//     activityWhen: "3d ago",
//   },
//   {
//     name: "Priya Singh",
//     initials: "PS",
//     color: "#16a34a",
//     role: "Frontend Engineer",
//     exp: "4 yrs",
//     location: "Noida",
//     salary: "10–14 LPA",
//     days: "Immediate",
//     source: "HR Upload",
//     sourceLabel: "HR Upload",
//     stage: "Shortlisted",
//     skills: ["Vue.js", "JavaScript", "React"],
//     lastNote: { text: '"Very articulate. Cultural fit excellent. All 3 rounds cleared."', by: "HR Team", when: "1d ago" },
//     job: "JOB-2026-001",
//     interviewStatus: { label: "3 Rounds Cleared", bg: "var(--green-lt)", color: "var(--green)" },
//     activityWhen: "1d ago",
//   },
//   {
//     name: "Amit Kumar",
//     initials: "AK",
//     color: "#d97706",
//     role: "UI Developer",
//     exp: "3 yrs",
//     location: "Gurgaon",
//     salary: "8–11 LPA",
//     days: "45d",
//     source: "ATS",
//     sourceLabel: "ATS",
//     stage: "Applied",
//     skills: ["React", "HTML/CSS", "Figma"],
//     lastNote: null,
//     job: "JOB-2026-001",
//     interviewStatus: { label: "No interview yet", bg: "var(--gray-lt)", color: "var(--gray)" },
//     activityWhen: "Applied 16d ago",
//   },
//   {
//     name: "Neha Kapoor",
//     initials: "NK",
//     color: "#7c3aed",
//     role: "React Developer",
//     exp: "6 yrs",
//     location: "Delhi",
//     salary: "18–22 LPA",
//     days: "Immediate",
//     source: "Referral",
//     sourceLabel: "Referral",
//     stage: "Offer Given",
//     skills: ["React", "Redux", "AWS", "TypeScript"],
//     lastNote: { text: '"Exceptional candidate. Offer sent 3d ago, awaiting response."', by: "Priya S.", when: null },
//     job: "JOB-2026-001",
//     interviewStatus: { label: "Offer Awaiting · 3d", bg: "#fef9c3", color: "#854d0e" },
//     activityWhen: null,
//   },
//   {
//     name: "Meera Joshi",
//     initials: "MJ",
//     color: "#0891b2",
//     role: "Full Stack Developer",
//     exp: "4 yrs",
//     location: "Bengaluru",
//     salary: "12–16 LPA",
//     days: "30d",
//     source: "Naukri",
//     sourceLabel: "Naukri",
//     stage: "Interview",
//     skills: ["React", "Node.js", "MongoDB"],
//     lastNote: { text: '"R1 Technical — Jun 22 — 4 days overdue"', by: "Neha Gupta", when: null, warn: true },
//     job: "JOB-2026-004",
//     interviewStatus: { label: "Feedback Overdue · 4d", bg: "var(--red-lt)", color: "var(--red)" },
//     activityWhen: null,
//   },
//   {
//     name: "Vikash Roy",
//     initials: "VR",
//     color: "#9ca3af",
//     role: "Frontend Dev",
//     exp: "2 yrs",
//     location: "Pune",
//     salary: "6–8 LPA",
//     days: null,
//     source: "ATS",
//     sourceLabel: "ATS",
//     stage: "Rejected",
//     skills: ["HTML", "CSS", "JavaScript"],
//     lastNote: { text: '"Good CSS, weak TypeScript. Rejection: skills mismatch."', by: "Rahul Dev", when: "4d ago" },
//     job: "JOB-2026-001",
//     interviewStatus: { label: "R1 Not Cleared · 4d ago", bg: "var(--red-lt)", color: "var(--red)" },
//     activityWhen: null,
//   },
// ];

// const STAGE_BADGE_CLASS = {
//   Applied: "sb-applied",
//   Screening: "sb-screening",
//   Interview: "sb-interview",
//   Shortlisted: "sb-shortlisted",
//   Negotiation: "sb-negotiation",
//   "Offer Given": "sb-offer",
//   Hired: "sb-hired",
//   Rejected: "sb-rejected",
// };

// const STAGE_CARD_CLASS = {
//   Applied: "stage-applied",
//   Interview: "stage-interview",
//   Shortlisted: "stage-shortlisted",
//   "Offer Given": "stage-offer",
//   Hired: "stage-hired",
//   Rejected: "stage-rejected",
// };

// const SOURCE_BADGE_CLASS = {
//   ATS: "src-ats",
//   "HR Upload": "src-hr",
//   Referral: "src-ref",
//   Naukri: "src-naukri",
//   LinkedIn: "src-linkedin",
//   Indeed: "src-indeed",
// };

// /* ----------------------------------------------------------------------
//    Validation schemas
// ---------------------------------------------------------------------- */
// const filterSchema = Yup.object({
//   search: Yup.string(),
//   stage: Yup.string(),
//   job: Yup.string(),
//   source: Yup.string(),
//   location: Yup.string(),
//   experienceMin: Yup.number().min(0, "Cannot be negative").nullable(),
//   experienceMax: Yup.number().min(0, "Cannot be negative").nullable(),
//   ctcMin: Yup.number().min(0, "Cannot be negative").nullable(),
//   ctcMax: Yup.number().min(0, "Cannot be negative").nullable(),
//   noticePeriod: Yup.string(),
//   currentCompany: Yup.string(),
//   keySkills: Yup.string(),
//   workMode: Yup.string(),
//   recruiter: Yup.string(),
//   addedAfter: Yup.string(),
//   lastActivity: Yup.string(),
//   hasResume: Yup.string(),
//   hasNotes: Yup.string(),
//   interviewStatus: Yup.string(),
// });

// const noteSchema = Yup.object({
//   note: Yup.string().trim().required("Note is required"),
// });

// const feedbackSchema = Yup.object({
//   technicalRating: Yup.number().min(1, "Please rate technical skills").required("Required"),
//   communicationRating: Yup.number().min(1, "Please rate communication").required("Required"),
//   recommendation: Yup.string().required("Please pick a recommendation"),
//   comments: Yup.string(),
// });

// const offerSchema = Yup.object({
//   job: Yup.string().required("Job is required"),
//   offerDate: Yup.date().required("Offer date is required"),
//   offerLetter: Yup.mixed().nullable(),
// });

// const hireSchema = Yup.object({
//   joiningDate: Yup.date().required("Joining date is required"),
//   department: Yup.string().required("Department is required"),
// });

// /* ----------------------------------------------------------------------
//    Small presentational helpers
// ---------------------------------------------------------------------- */
// function Toast({ message, onDone }) {
//   useEffect(() => {
//     const t = setTimeout(onDone, 2800);
//     return () => clearTimeout(t);
//   }, [onDone]);
//   if (!message) return null;
//   return (
//     <div className="og-toast">
//       <i className="fa-solid fa-check-circle" style={{ color: "#4ade80" }}></i>
//       {message}
//     </div>
//   );
// }

// function RatingPicker({ value, onChange }) {
//   return (
//     <div style={{ display: "flex", gap: ".15rem" }}>
//       {Array.from({ length: 10 }, (_, i) => i + 1).map((n) => (
//         <button
//           key={n}
//           type="button"
//           className={`rating-btn${value >= n ? " active" : ""}`}
//           onClick={() => onChange(n)}
//         >
//           {n}
//         </button>
//       ))}
//     </div>
//   );
// }

// function NoteModal({ candidate, onClose, onSaved }) {
//   if (!candidate) return null;
//   return (
//     <div className="modal-overlay open" onClick={(e) => e.target === e.currentTarget && onClose()}>
//       <div className="modal-box">
//         <Formik
//           initialValues={{ note: "" }}
//           validationSchema={noteSchema}
//           onSubmit={async (values, { setSubmitting }) => {
//             try {

//               onSaved("Note added successfully");
//             } finally {
//               setSubmitting(false);
//             }
//           }}
//         >
//           {({ isSubmitting }) => (
//             <Form>
//               <div className="modal-head">
//                 <div className="modal-icon" style={{ background: "#fffbeb" }}>
//                   <i className="fa-solid fa-note-sticky" style={{ color: "var(--amber)" }}></i>
//                 </div>
//                 <div style={{ flex: 1 }}>
//                   <div className="modal-title">Add Note</div>
//                   <div className="modal-sub">{candidate.name}</div>
//                 </div>
//                 <button type="button" className="modal-close-btn" onClick={onClose}>
//                   <i className="fa-solid fa-times"></i>
//                 </button>
//               </div>
//               <div className="modal-body">
//                 <div className="fg">
//                   <label>
//                     Note <span style={{ color: "var(--primary)" }}>*</span>
//                   </label>
//                   <Field as="textarea" name="note" rows="4" className="og-textarea" placeholder="Add internal note about this candidate…" />
//                   <ErrorMessage name="note" component="div" className="fg-error" />
//                 </div>
//               </div>
//               <div className="modal-foot">
//                 <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>
//                   Cancel
//                 </button>
//                 <button type="submit" className="btn btn-primary btn-sm" disabled={isSubmitting}>
//                   <i className="fa-solid fa-check"></i> Save Note
//                 </button>
//               </div>
//             </Form>
//           )}
//         </Formik>
//       </div>
//     </div>
//   );
// }

// /* ----------------------------------------------------------------------
//    Modal: Interview Feedback
// ---------------------------------------------------------------------- */
// function FeedbackModal({ candidate, onClose, onSaved }) {
//   if (!candidate) return null;
//   return (
//     <div className="modal-overlay open" onClick={(e) => e.target === e.currentTarget && onClose()}>
//       <div className="modal-box" style={{ maxWidth: 540 }}>
//         <Formik
//           initialValues={{ technicalRating: 0, communicationRating: 0, recommendation: "Reject", comments: "" }}
//           validationSchema={feedbackSchema}
//           onSubmit={async (values, { setSubmitting }) => {
//             try {
//               // await submitInterviewFeedback({ candidateId: candidate.id, ...values });
//               onSaved("Feedback submitted");
//             } finally {
//               setSubmitting(false);
//             }
//           }}
//         >
//           {({ values, setFieldValue, isSubmitting }) => (
//             <Form>
//               <div className="modal-head">
//                 <div className="modal-icon" style={{ background: "#fffbeb" }}>
//                   <i className="fa-solid fa-star" style={{ color: "var(--amber)" }}></i>
//                 </div>
//                 <div style={{ flex: 1 }}>
//                   <div className="modal-title">Submit Interview Feedback</div>
//                   <div className="modal-sub">{candidate.name}</div>
//                 </div>
//                 <button type="button" className="modal-close-btn" onClick={onClose}>
//                   <i className="fa-solid fa-times"></i>
//                 </button>
//               </div>
//               <div className="modal-body">
//                 <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: ".75rem", marginBottom: ".75rem" }}>
//                   <div>
//                     <div style={{ fontSize: ".78rem", fontWeight: 700, marginBottom: ".3rem" }}>Technical Skills</div>
//                     <RatingPicker value={values.technicalRating} onChange={(n) => setFieldValue("technicalRating", n)} />
//                     <ErrorMessage name="technicalRating" component="div" className="fg-error" />
//                   </div>
//                   <div>
//                     <div style={{ fontSize: ".78rem", fontWeight: 700, marginBottom: ".3rem" }}>Communication</div>
//                     <RatingPicker value={values.communicationRating} onChange={(n) => setFieldValue("communicationRating", n)} />
//                     <ErrorMessage name="communicationRating" component="div" className="fg-error" />
//                   </div>
//                 </div>
//                 <div style={{ marginBottom: ".75rem" }}>
//                   <div style={{ fontSize: ".78rem", fontWeight: 700, marginBottom: ".3rem" }}>Overall Recommendation</div>
//                   <div style={{ display: "flex", gap: ".75rem" }}>
//                     {[
//                       { value: "Proceed", color: "var(--green)" },
//                       { value: "Maybe", color: "var(--amber)" },
//                       { value: "Reject", color: "var(--red)" },
//                     ].map((opt) => (
//                       <label key={opt.value} style={{ display: "flex", alignItems: "center", gap: ".35rem", cursor: "pointer", fontSize: ".85rem" }}>
//                         <Field type="radio" name="recommendation" value={opt.value} style={{ accentColor: opt.color }} />
//                         <span style={{ color: opt.color, fontWeight: 600 }}>{opt.value}</span>
//                       </label>
//                     ))}
//                   </div>
//                   <ErrorMessage name="recommendation" component="div" className="fg-error" />
//                 </div>
//                 <Field as="textarea" name="comments" rows="3" className="og-textarea" placeholder="Comments…" />
//               </div>
//               <div className="modal-foot">
//                 <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>
//                   Cancel
//                 </button>
//                 <button type="submit" className="btn btn-primary btn-sm" disabled={isSubmitting}>
//                   <i className="fa-solid fa-check"></i> Submit Feedback
//                 </button>
//               </div>
//             </Form>
//           )}
//         </Formik>
//       </div>
//     </div>
//   );
// }

// /* ----------------------------------------------------------------------
//    Modal: Give Offer
// ---------------------------------------------------------------------- */
// function OfferModal({ candidate, onClose, onSaved }) {
//   if (!candidate) return null;
//   return (
//     <div className="modal-overlay open" onClick={(e) => e.target === e.currentTarget && onClose()}>
//       <div className="modal-box">
//         <Formik
//           initialValues={{ job: "JOB-2026-001 — Senior Frontend Developer", offerDate: "", offerLetter: null }}
//           validationSchema={offerSchema}
//           onSubmit={async (values, { setSubmitting }) => {
//             try {
//               const formData = new FormData();
//               formData.append("job", values.job);
//               formData.append("offerDate", values.offerDate);
//               if (values.offerLetter) formData.append("offerLetter", values.offerLetter);
//               // await sendCandidateOffer(candidate.id, formData);
//               onSaved("Offer sent — candidate will be notified via ATS");
//             } finally {
//               setSubmitting(false);
//             }
//           }}
//         >
//           {({ setFieldValue, isSubmitting }) => (
//             <Form>
//               <div className="modal-head">
//                 <div className="modal-icon" style={{ background: "#f0fdf4" }}>
//                   <i className="fa-solid fa-file-contract" style={{ color: "var(--green)" }}></i>
//                 </div>
//                 <div style={{ flex: 1 }}>
//                   <div className="modal-title">Give Offer</div>
//                   <div className="modal-sub">{candidate.name}</div>
//                 </div>
//                 <button type="button" className="modal-close-btn" onClick={onClose}>
//                   <i className="fa-solid fa-times"></i>
//                 </button>
//               </div>
//               <div className="modal-body">
//                 <div className="fg">
//                   <label>Job</label>
//                   <Field as="select" name="job" className="og-select">
//                     <option>JOB-2026-001 — Senior Frontend Developer</option>
//                   </Field>
//                 </div>
//                 <div className="fg">
//                   <label>
//                     Offer Date <span style={{ color: "var(--primary)" }}>*</span>
//                   </label>
//                   <Field type="date" name="offerDate" className="og-input" />
//                   <ErrorMessage name="offerDate" component="div" className="fg-error" />
//                 </div>
//                 <div className="fg">
//                   <label>
//                     Offer Letter PDF <span style={{ fontSize: ".72rem", fontWeight: 400, color: "var(--muted)" }}>(optional)</span>
//                   </label>
//                   <input
//                     type="file"
//                     accept=".pdf"
//                     className="og-input"
//                     style={{ padding: ".4rem .6rem" }}
//                     onChange={(e) => setFieldValue("offerLetter", e.currentTarget.files[0])}
//                   />
//                 </div>
//               </div>
//               <div className="modal-foot">
//                 <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>
//                   Cancel
//                 </button>
//                 <button type="submit" className="btn btn-primary btn-sm" style={{ background: "var(--green)" }} disabled={isSubmitting}>
//                   <i className="fa-solid fa-paper-plane"></i> Send Offer
//                 </button>
//               </div>
//             </Form>
//           )}
//         </Formik>
//       </div>
//     </div>
//   );
// }

// /* ----------------------------------------------------------------------
//    Modal: Create Employee (Hire)
// ---------------------------------------------------------------------- */
// function HireModal({ candidate, onClose, onSaved }) {
//   if (!candidate) return null;
//   return (
//     <div className="modal-overlay open" onClick={(e) => e.target === e.currentTarget && onClose()}>
//       <div className="modal-box">
//         <Formik
//           initialValues={{ joiningDate: "", department: "" }}
//           validationSchema={hireSchema}
//           onSubmit={async (values, { setSubmitting }) => {
//             try {
//               // await createEmployeeFromCandidate(candidate.id, values);
//               onSaved("Employee creation form opened");
//             } finally {
//               setSubmitting(false);
//             }
//           }}
//         >
//           {({ isSubmitting }) => (
//             <Form>
//               <div className="modal-head">
//                 <div className="modal-icon" style={{ background: "#dcfce7" }}>
//                   <i className="fa-solid fa-user-check" style={{ color: "#14532d" }}></i>
//                 </div>
//                 <div style={{ flex: 1 }}>
//                   <div className="modal-title">Create Employee Record</div>
//                   <div className="modal-sub">{candidate.name}</div>
//                 </div>
//                 <button type="button" className="modal-close-btn" onClick={onClose}>
//                   <i className="fa-solid fa-times"></i>
//                 </button>
//               </div>
//               <div className="modal-body">
//                 <p style={{ fontSize: ".85rem", color: "var(--muted)", margin: "0 0 .85rem", lineHeight: 1.6 }}>
//                   Candidate data will be pre-filled in the employee form. Review and save.
//                 </p>
//                 <div className="fg">
//                   <label>
//                     Joining Date <span style={{ color: "var(--primary)" }}>*</span>
//                   </label>
//                   <Field type="date" name="joiningDate" className="og-input" />
//                   <ErrorMessage name="joiningDate" component="div" className="fg-error" />
//                 </div>
//                 <div className="fg">
//                   <label>Department</label>
//                   <Field type="text" name="department" className="og-input" placeholder="Engineering" />
//                   <ErrorMessage name="department" component="div" className="fg-error" />
//                 </div>
//               </div>
//               <div className="modal-foot">
//                 <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>
//                   Cancel
//                 </button>
//                 <button type="submit" className="btn btn-primary btn-sm" style={{ background: "var(--green)" }} disabled={isSubmitting}>
//                   <i className="fa-solid fa-user-plus"></i> Create Employee
//                 </button>
//               </div>
//             </Form>
//           )}
//         </Formik>
//       </div>
//     </div>
//   );
// }

// /* ----------------------------------------------------------------------
//    Candidate card
// ---------------------------------------------------------------------- */
// function CandidateCard({ c, onOpenNote, onOpenFeedback, onOpenOffer, onOpenHire, navigate }) {
//   return (
//     <div className={`cand-card-bx ${STAGE_CARD_CLASS[c.stage] || ""}`}>
//       <div className="cc-top">
//         <div className="cc-av" style={{ background: c.color }}>
//           {c.initials}
//         </div>
//         <div className="cc-info">
//           <div className="cc-name" onClick={() => navigate("recruitment-candidate-profile.html")}>
//             {c.name}
//           </div>
//           <div className="cc-role">
//             {c.role} · {c.exp}
//           </div>
//           <div className="cc-meta">
//             <span className="cc-meta-item">
//               <i className="fa-solid fa-location-dot" style={{ fontSize: ".62rem" }}></i> {c.location}
//             </span>
//             <span className="cc-meta-item">
//               <i className="fa-solid fa-indian-rupee-sign" style={{ fontSize: ".62rem" }}></i> {c.salary}
//             </span>
//             {c.days && (
//               <span className="cc-meta-item">
//                 <i className="fa-solid fa-user-clock" style={{ fontSize: ".62rem" }}></i> {c.days}
//               </span>
//             )}
//             <span className={`source-badge ${SOURCE_BADGE_CLASS[c.source] || ""}`}>{c.sourceLabel}</span>
//           </div>
//         </div>
//         <span className={`stage-badge ${STAGE_BADGE_CLASS[c.stage] || ""}`} style={{ alignSelf: "flex-start", flexShrink: 0 }}>
//           {c.stage}
//         </span>
//       </div>

//       <div className="cc-skills">
//         {c.skills.map((s) => (
//           <span className="skill-chip" key={s}>
//             {s}
//           </span>
//         ))}
//       </div>

//       <div className="cc-activity">
//         {c.lastNote ? (
//           <div className="cc-last-note" style={c.lastNote.warn ? { color: "var(--red)" } : undefined}>
//             <strong>{c.lastNote.warn ? "⚠ Feedback pending:" : "Last note:"}</strong> {c.lastNote.text} — {c.lastNote.by}
//             {c.lastNote.when ? ` · ${c.lastNote.when}` : ""}
//           </div>
//         ) : (
//           <div className="cc-last-note" style={{ color: "var(--muted)", fontStyle: "normal" }}>
//             <i className="fa-solid fa-minus" style={{ fontSize: ".6rem", marginRight: ".25rem" }}></i>No notes yet
//           </div>
//         )}
//         <div className="cc-job-row">
//           <i className="fa-solid fa-briefcase" style={{ fontSize: ".62rem", color: "var(--muted)" }}></i>
//           <span style={{ color: "var(--text)", fontWeight: 600, fontSize: ".72rem" }}>{c.job}</span>
//           <span className="cc-int-status" style={{ background: c.interviewStatus.bg, color: c.interviewStatus.color }}>
//             {c.interviewStatus.label}
//           </span>
//           {c.activityWhen && <span style={{ color: "var(--muted)", fontSize: ".7rem" }}>· {c.activityWhen}</span>}
//         </div>
//       </div>

//       <div className="cc-foot">
//         <button className="btn btn-outline btn-xs" onClick={() => navigate("recruitment-candidate-profile.html")}>
//           <i className="fa-solid fa-eye"></i> Profile
//         </button>

//         {c.stage === "Applied" && (
//           <>
//             <button className="btn btn-primary btn-xs" onClick={() => navigate("recruitment-interview-schedule.html")}>
//               <i className="fa-solid fa-calendar-plus"></i> Schedule
//             </button>
//             <button className="btn-ghost btn-xs" onClick={() => navigate("recruitment-link-candidate.html")} title="Link job">
//               <i className="fa-solid fa-link"></i>
//             </button>
//             <button className="btn-ghost btn-xs" onClick={() => onOpenNote(c)} title="Add note">
//               <i className="fa-solid fa-note-sticky"></i>
//             </button>
//           </>
//         )}

//         {c.stage === "Interview" && !c.lastNote?.warn && (
//           <>
//             <button className="btn btn-primary btn-xs" onClick={() => navigate("recruitment-link-candidate.html")}>
//               <i className="fa-solid fa-link"></i> Link Job
//             </button>
//             <button className="btn-ghost btn-xs" onClick={() => navigate("recruitment-interview-schedule.html")} title="Schedule interview">
//               <i className="fa-solid fa-calendar-plus"></i>
//             </button>
//             <button className="btn-ghost btn-xs" onClick={() => onOpenNote(c)} title="Add note">
//               <i className="fa-solid fa-note-sticky"></i>
//             </button>
//           </>
//         )}

//         {c.stage === "Interview" && c.lastNote?.warn && (
//           <>
//             <button className="btn btn-warn btn-xs" onClick={() => onOpenFeedback(c)}>
//               <i className="fa-solid fa-star"></i> Add Feedback
//             </button>
//             <button className="btn-ghost btn-xs" onClick={() => onOpenNote(c)}>
//               <i className="fa-solid fa-note-sticky"></i>
//             </button>
//           </>
//         )}

//         {c.stage === "Shortlisted" && (
//           <>
//             <button className="btn btn-primary btn-xs" onClick={() => onOpenOffer(c)}>
//               <i className="fa-solid fa-file-contract"></i> Give Offer
//             </button>
//             <button className="btn-ghost btn-xs" onClick={() => onOpenNote(c)} title="Add note">
//               <i className="fa-solid fa-note-sticky"></i>
//             </button>
//           </>
//         )}

//         {c.stage === "Offer Given" && (
//           <>
//             <button className="btn btn-success btn-xs" onClick={() => onOpenHire(c)}>
//               <i className="fa-solid fa-user-check"></i> Create Employee
//             </button>
//             <button className="btn-ghost btn-xs" onClick={() => onOpenNote(c, true)} title="Send reminder">
//               <i className="fa-solid fa-bell"></i>
//             </button>
//           </>
//         )}

//         {c.stage === "Rejected" && (
//           <button className="btn btn-secondary btn-xs" onClick={() => navigate("recruitment-link-candidate.html")}>
//             <i className="fa-solid fa-link"></i> Re-consider
//           </button>
//         )}
//       </div>
//     </div>
//   );
// }

// /* ----------------------------------------------------------------------
//    Filter bar (Formik-driven)
// ---------------------------------------------------------------------- */
// function FilterBar({ onSubmitFilters, moreOpen, setMoreOpen }) {
//   return (
//     <Formik
//       initialValues={{
//         search: "",
//         stage: "",
//         job: "",
//         source: "",
//         location: "",
//         experienceMin: "",
//         experienceMax: "",
//         ctcMin: "",
//         ctcMax: "",
//         noticePeriod: "Any",
//         currentCompany: "",
//         keySkills: "",
//         workMode: "Any",
//         recruiter: "Anyone",
//         addedAfter: "",
//         lastActivity: "Any time",
//         hasResume: "Any",
//         hasNotes: "Any",
//         interviewStatus: "Any",
//       }}
//       validationSchema={filterSchema}
//       onSubmit={(values) => onSubmitFilters(values)}
//     >
//       {({ values, handleChange, submitForm, resetForm }) => {
//         // live-filter as the user types/selects on the primary row

//         return (
//           <Form className="filter-bar">
//             <div className="filter-row">
//               <div className="search-wrap">
//                 <i className="fa-solid fa-magnifying-glass"></i>
//                 <Field
//                   className="search-input"
//                   name="search"
//                   placeholder="Search name, email, skills, company, location…"
//                 />
//               </div>

//               <Field as="select" className="fs-select" name="stage">
//                 <option value="">All Stages</option>
//                 <option>Applied</option>
//                 <option>Screening</option>
//                 <option>Interview</option>
//                 <option>Shortlisted</option>
//                 <option>Negotiation</option>
//                 <option>Offer Given</option>
//                 <option>Hired</option>
//                 <option>Rejected</option>
//               </Field>

//               <Field as="select" className="fs-select" name="job">
//                 <option value="">All Jobs</option>
//                 <option>JOB-2026-001 — Sr Frontend Dev</option>
//                 <option>JOB-2026-002 — Product Manager</option>
//                 <option>JOB-2026-004 — Data Analyst</option>
//                 <option>JOB-2026-005 — Sr Backend Engineer</option>
//               </Field>

//               <Field as="select" className="fs-select" name="source">
//                 <option value="">All Sources</option>
//                 <option>ATS / Direct apply</option>
//                 <option>HR Upload</option>
//                 <option>Referral</option>
//                 <option>Naukri</option>
//                 <option>LinkedIn</option>
//                 <option>Indeed</option>
//                 <option>Walkup</option>
//               </Field>

//               <button type="button" className="btn btn-outline btn-sm" onClick={() => setMoreOpen(!moreOpen)}>
//                 <i className="fa-solid fa-sliders"></i> {moreOpen ? "Hide Filters" : "More Filters"}
//               </button>
//               <button
//                 type="button"
//                 className="btn-ghost btn-xs"
//                 title="Clear all filters"
//                 onClick={() => {
//                   resetForm();
//                   submitForm();
//                 }}
//               >
//                 <i className="fa-solid fa-xmark"></i> Clear
//               </button>
//             </div>

//             <div className={`more-panel${moreOpen ? " open" : ""}`}>
//               <div className="mp-g">
//                 <label>Location</label>
//                 <Field className="mp-input" name="location" placeholder="City or Remote" />
//               </div>
//               <div className="mp-g">
//                 <label>Experience Min (yrs)</label>
//                 <Field className="mp-input" type="number" name="experienceMin" placeholder="0" min="0" />
//                 <ErrorMessage name="experienceMin" component="div" className="fg-error" />
//               </div>
//               <div className="mp-g">
//                 <label>Experience Max (yrs)</label>
//                 <Field className="mp-input" type="number" name="experienceMax" placeholder="15" min="0" />
//                 <ErrorMessage name="experienceMax" component="div" className="fg-error" />
//               </div>
//               <div className="mp-g">
//                 <label>Salary Min (LPA)</label>
//                 <Field className="mp-input" type="number" name="ctcMin" placeholder="0" min="0" />
//               </div>
//               <div className="mp-g">
//                 <label>Salary Max (LPA)</label>
//                 <Field className="mp-input" type="number" name="ctcMax" placeholder="50" min="0" />
//               </div>
//               <div className="mp-g">
//                 <label>Notice Period</label>
//                 <Field as="select" className="mp-input" name="noticePeriod">
//                   <option>Any</option>
//                   <option>Immediate</option>
//                   <option>15 days</option>
//                   <option>30 days</option>
//                   <option>45 days</option>
//                   <option>60 days</option>
//                   <option>90 days</option>
//                 </Field>
//               </div>
//               <div className="mp-g">
//                 <label>Current Company</label>
//                 <Field className="mp-input" name="currentCompany" placeholder="Company name…" />
//               </div>
//               <div className="mp-g">
//                 <label>Key Skills (comma sep.)</label>
//                 <Field className="mp-input" name="keySkills" placeholder="React, TypeScript…" />
//               </div>
//               <div className="mp-g">
//                 <label>Work Mode Preference</label>
//                 <Field as="select" className="mp-input" name="workMode">
//                   <option>Any</option>
//                   <option>Remote only</option>
//                   <option>Hybrid</option>
//                   <option>On-site</option>
//                 </Field>
//               </div>
//               <div className="mp-g">
//                 <label>Recruiter</label>
//                 <Field as="select" className="mp-input" name="recruiter">
//                   <option>Anyone</option>
//                   <option>Priya Sharma</option>
//                   <option>Neha Gupta</option>
//                   <option>Arun Mishra</option>
//                 </Field>
//               </div>
//               <div className="mp-g">
//                 <label>Added After</label>
//                 <Field className="mp-input" type="date" name="addedAfter" />
//               </div>
//               <div className="mp-g">
//                 <label>Last Activity Within</label>
//                 <Field as="select" className="mp-input" name="lastActivity">
//                   <option>Any time</option>
//                   <option>Last 7 days</option>
//                   <option>Last 30 days</option>
//                   <option>Last 90 days</option>
//                 </Field>
//               </div>
//               <div className="mp-g">
//                 <label>Has Resume?</label>
//                 <Field as="select" className="mp-input" name="hasResume">
//                   <option>Any</option>
//                   <option>Yes</option>
//                   <option>No</option>
//                 </Field>
//               </div>
//               <div className="mp-g">
//                 <label>Has Notes?</label>
//                 <Field as="select" className="mp-input" name="hasNotes">
//                   <option>Any</option>
//                   <option>Has notes</option>
//                   <option>No notes yet</option>
//                 </Field>
//               </div>
//               <div className="mp-g">
//                 <label>Interview Status</label>
//                 <Field as="select" className="mp-input" name="interviewStatus">
//                   <option>Any</option>
//                   <option>No interview yet</option>
//                   <option>Interview scheduled</option>
//                   <option>Feedback pending</option>
//                   <option>All rounds cleared</option>
//                 </Field>
//               </div>
//               <div className="mp-g" style={{ display: "flex", alignItems: "flex-end", gap: ".4rem" }}>
//                 <button type="submit" className="btn btn-primary btn-sm" style={{ flex: 1, justifyContent: "center" }}>
//                   Apply
//                 </button>
//                 <button type="button" className="btn btn-outline btn-sm" onClick={() => setMoreOpen(false)}>
//                   Clear
//                 </button>
//               </div>
//             </div>
//           </Form>
//         );
//       }}
//     </Formik>
//   );
// }

// /* ----------------------------------------------------------------------
//    Main page
// ---------------------------------------------------------------------- */
// export default function CandidatesPage() {
//   const [candidates, setCandidates] = useState(FALLBACK_CANDIDATES);
//   const [loading, setLoading] = useState(false);
//   const [view, setView] = useState("cards");
//   const [summaryOpen, setSummaryOpen] = useState(true);
//   const [moreOpen, setMoreOpen] = useState(false);
//   const [toastMsg, setToastMsg] = useState("");
//   const [noteFor, setNoteFor] = useState(null);
//   const [feedbackFor, setFeedbackFor] = useState(null);
//   const [offerFor, setOfferFor] = useState(null);
//   const [hireFor, setHireFor] = useState(null);
//   const [activeFilters, setActiveFilters] = useState(null);

//   const navigate = (path) => {
//     window.location.href = path;
//   };

//   const fetchCandidates = async (filters) => {
//     setLoading(true);
//     const params = {
//       CandidateId: 0,
//       Guid: "",
//       JobId: filters?.job ? filters.job.split(" ")[0] : 0,
//       CandidatureStageId: filters?.stage || "",
//       CandidateSourceId: filters?.source || "",
//       WorkModePreferenceId: filters?.workMode && filters.workMode !== "Any" ? filters.workMode : "",
//       ExperienceMin: filters?.experienceMin || 0,
//       ExperienceMax: filters?.experienceMax || 0,
//       CTCMin: filters?.ctcMin || 0,
//       CTCMax: filters?.ctcMax || 0,
//       HasResume: filters?.hasResume === "Yes" ? 1 : filters?.hasResume === "No" ? 0 : 0,
//       Search: filters?.search || "",
//       AddedFrom: filters?.addedAfter || "",
//       AddedTo: "",
//       PageNumber: 1,
//       PageSize: 50,
//       SortBy: "CreatedOn",
//       SortOrder: "desc",
//     };

//     try {
//       const res = await getCandidateList(params);
//       if (res?.Data?.length) {
//         setCandidates(res.Data);
//       }
//     } catch (error) {
//       // keep fallback data on failure
//       console.error("Failed to load candidates", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchCandidates();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   const handleFilterSubmit = (values) => {
//     setActiveFilters(values);
//     fetchCandidates(values);
//   };

//   const filteredCandidates = candidates; // server-side filtered via fetchCandidates

//   const showToast = (msg) => setToastMsg(msg);

//   const quickFilter = (stageOrActive) => {
//     if (stageOrActive === "active") {
//       handleFilterSubmit({ ...activeFilters, stage: "" }); // server should handle "active" segment separately if needed
//     } else {
//       handleFilterSubmit({ ...activeFilters, stage: stageOrActive });
//     }
//   };

//   return (



//       <div className="main">
//         <div className="topbar">
//           <i className="fa-solid fa-user-tie" ></i>
//           <div className="breadcrumb topbar-breadcrumb" >
//             <a href="#">Recruitment</a>
//             <i className="fa-solid fa-chevron-right" ></i>
//             <strong className="topbar-current">Candidates</strong>
//           </div>
//           <div className="top-right">
//             <div className="user-mini">
//               <div className="top-avatar">AM</div>
//               <div>
//                 <div className="user-name">Arun Mishra</div>
//                 <div className="user-role">HR Admin</div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="container-fluid position-relation">
//           <div className="Page-head">
//             <div className="leftside-head">
//               <h2>
//                 <i className="fa-solid fa-user-tie"></i>
//                 Candidate Database
//               </h2>
//               <div className="breadcrumb">Shared candidate pool — one record per person across all jobs</div>
//             </div>
//             <div className="Left-head-side">
//               <div className="view-toggle">
//                 <button className={`vt-btn${view === "cards" ? " active" : ""}`} onClick={() => setView("cards")}>
//                   <i className="fa-solid fa-table-cells-large"></i> Cards
//                 </button>
//                 <button className={`vt-btn${view === "table" ? " active" : ""}`} onClick={() => setView("table")}>
//                   <i className="fa-solid fa-table-list"></i> Table
//                 </button>
//               </div>
//               <Link to="/Recruitment/Candidate-CVUpload" className="btn btn-outline btn-sm btn-gray" >
//                 <i className="fa-solid fa-cloud-arrow-up"></i> Upload CV
//               </Link>
//               <Link to="/Recruitment/Recruitment-Candidate-Add" className="btn btn-primary btn-sm ">
//                 <i className="fa-solid fa-user-plus"></i> Add Candidate
//               </Link>
//             </div>
//           </div>

//           {/* Stats strip */}
//           <div className="stat-strip">
//             <div className="stat-card sc-total" onClick={() => handleFilterSubmit(null)}>
//               <div className="stat-lbl">Total</div>
//               <div className="stat-val" style={{ color: "var(--primary)" }}>148</div>
//               <div className="stat-sub">In database</div>
//             </div>
//             <div className="stat-card sc-active" onClick={() => quickFilter("active")}>
//               <div className="stat-lbl">Active</div>
//               <div className="stat-val" style={{ color: "var(--amber)" }}>62</div>
//               <div className="stat-sub">In active pipeline</div>
//             </div>
//             <div className="stat-card sc-int" onClick={() => quickFilter("Interview")}>
//               <div className="stat-lbl">In Interview</div>
//               <div className="stat-val" style={{ color: "var(--blue)" }}>19</div>
//               <div className="stat-sub">Rounds ongoing</div>
//             </div>
//             <div className="stat-card sc-hired" onClick={() => quickFilter("Hired")}>
//               <div className="stat-lbl">Hired (Q2)</div>
//               <div className="stat-val" style={{ color: "var(--green)" }}>8</div>
//               <div className="stat-sub">This quarter</div>
//             </div>
//             <div className="stat-card sc-rej" onClick={() => quickFilter("Rejected")}>
//               <div className="stat-lbl">Rejected</div>
//               <div className="stat-val" style={{ color: "var(--gray)" }}>78</div>
//               <div className="stat-sub">All time</div>
//             </div>
//           </div>

//           {/* Summary section */}
//           <div className="summary-section">
//             <div className="summary-toggle" onClick={() => setSummaryOpen(!summaryOpen)}>
//               <h5>
//                 <i className="fa-solid fa-chart-pie" style={{ color: "var(--primary)", fontSize: ".82rem" }}></i> Candidate Analytics &amp; Summary
//               </h5>
//               <div style={{ display: "flex", alignItems: "center", gap: ".75rem" }}>
//                 <span style={{ fontSize: ".75rem", color: "var(--muted)" }}>148 total across 24 open jobs</span>
//                 <i
//                   className="fa-solid fa-chevron-up"
//                   style={{ fontSize: ".75rem", color: "var(--muted)", transition: "transform .2s", transform: summaryOpen ? "rotate(0deg)" : "rotate(180deg)" }}
//                 ></i>
//               </div>
//             </div>

//             {summaryOpen && (
//               <div className="summary-body">
//                 <div className="charts-grid">
//                   <div className="chart-panel">
//                     <div className="chart-title">
//                       <i className="fa-solid fa-pipe-section" style={{ color: "var(--primary)", fontSize: ".72rem" }}></i> By Pipeline Stage
//                     </div>
//                     <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
//                       <svg width="80" height="80" viewBox="0 0 80 80">
//                         <circle cx="40" cy="40" r="28" fill="none" stroke="#f3f4f6" strokeWidth="12" />
//                         <circle cx="40" cy="40" r="28" fill="none" stroke="#6366f1" strokeWidth="12" strokeDasharray="52.8 123.6" strokeDashoffset="0" transform="rotate(-90 40 40)" />
//                         <circle cx="40" cy="40" r="28" fill="none" stroke="var(--amber)" strokeWidth="12" strokeDasharray="37.6 138.8" strokeDashoffset="-52.8" transform="rotate(-90 40 40)" />
//                         <circle cx="40" cy="40" r="28" fill="none" stroke="var(--green)" strokeWidth="12" strokeDasharray="25.1 151.3" strokeDashoffset="-90.4" transform="rotate(-90 40 40)" />
//                         <circle cx="40" cy="40" r="28" fill="none" stroke="var(--purple)" strokeWidth="12" strokeDasharray="9.4 167" strokeDashoffset="-115.5" transform="rotate(-90 40 40)" />
//                         <text x="40" y="37" textAnchor="middle" fontFamily="Onest,Arial" fontSize="12" fontWeight="700" fill="#1e2a3a">148</text>
//                         <text x="40" y="50" textAnchor="middle" fontFamily="Onest,Arial" fontSize="7" fill="#8492a6">total</text>
//                       </svg>
//                       <div style={{ flex: 1 }}>
//                         {[
//                           ["#6366f1", "Applied", 42],
//                           ["var(--amber)", "Interview", 30],
//                           ["var(--green)", "Shortlisted", 20],
//                           ["var(--purple)", "Offer+", 7],
//                           ["var(--gray)", "Rejected", 49],
//                         ].map(([color, label, count], idx) => (
//                           <div key={label} style={{ display: "flex", justifyContent: "space-between", fontSize: ".72rem", marginBottom: idx < 4 ? 3 : 0 }}>
//                             <span style={{ display: "flex", alignItems: "center", gap: ".3rem" }}>
//                               <span style={{ width: 8, height: 8, borderRadius: "50%", background: color }}></span>
//                               {label}
//                             </span>
//                             <strong>{count}</strong>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   </div>

//                   <div className="chart-panel">
//                     <div className="chart-title">
//                       <i className="fa-solid fa-arrow-pointer" style={{ color: "var(--primary)", fontSize: ".72rem" }}></i> By Source
//                     </div>
//                     {[
//                       ["ATS / Direct", "54%", "#6366f1", 80],
//                       ["HR Upload", "25%", "var(--purple)", 37],
//                       ["Referral", "11%", "var(--green)", 16],
//                       ["Naukri", "7%", "var(--amber)", 10],
//                       ["LinkedIn", "3%", "var(--blue)", 5],
//                     ].map(([label, width, color, count]) => (
//                       <div className="bar-row" key={label}>
//                         <span className="bar-label">{label}</span>
//                         <div className="bar-track">
//                           <div className="bar-fill" style={{ width, background: color }}></div>
//                         </div>
//                         <span className="bar-count">{count}</span>
//                       </div>
//                     ))}
//                   </div>

//                   <div className="chart-panel">
//                     <div className="chart-title">
//                       <i className="fa-solid fa-location-dot" style={{ color: "var(--primary)", fontSize: ".72rem" }}></i> By Location
//                     </div>
//                     {[
//                       ["Delhi / NCR", "43%", "var(--primary)", 64],
//                       ["Bengaluru", "28%", "#0891b2", 41],
//                       ["Mumbai", "11%", "var(--amber)", 16],
//                       ["Remote", "9%", "var(--green)", 14],
//                       ["Other", "9%", "var(--gray)", 13],
//                     ].map(([label, width, color, count]) => (
//                       <div className="bar-row" key={label}>
//                         <span className="bar-label">{label}</span>
//                         <div className="bar-track">
//                           <div className="bar-fill" style={{ width, background: color }}></div>
//                         </div>
//                         <span className="bar-count">{count}</span>
//                       </div>
//                     ))}
//                   </div>
//                 </div>

//                 <div className="charts-grid" style={{ borderBottom: "none" }}>
//                   <div className="chart-panel">
//                     <div className="chart-title">
//                       <i className="fa-solid fa-briefcase" style={{ color: "var(--primary)", fontSize: ".72rem" }}></i> By Experience Range
//                     </div>
//                     {[
//                       ["0–2 yrs", "15%", "#94a3b8", 22],
//                       ["2–4 yrs", "28%", "#6366f1", 42],
//                       ["4–6 yrs", "35%", "var(--primary)", 52],
//                       ["6–8 yrs", "13%", "var(--amber)", 19],
//                       ["8+ yrs", "9%", "var(--green)", 13],
//                     ].map(([label, width, color, count]) => (
//                       <div className="bar-row" key={label}>
//                         <span className="bar-label">{label}</span>
//                         <div className="bar-track">
//                           <div className="bar-fill" style={{ width, background: color }}></div>
//                         </div>
//                         <span className="bar-count">{count}</span>
//                       </div>
//                     ))}
//                   </div>

//                   <div className="chart-panel">
//                     <div className="chart-title">
//                       <i className="fa-solid fa-tags" style={{ color: "var(--primary)", fontSize: ".72rem" }}></i> Top Skills in Database
//                     </div>
//                     {[
//                       ["React", "78%", "#6366f1", 115],
//                       ["TypeScript", "65%", "#0891b2", 96],
//                       ["Node.js", "42%", "var(--green)", 62],
//                       ["Python", "35%", "var(--amber)", 52],
//                       ["SQL", "29%", "var(--primary)", 43],
//                     ].map(([label, width, color, count]) => (
//                       <div className="bar-row" key={label}>
//                         <span className="bar-label">{label}</span>
//                         <div className="bar-track">
//                           <div className="bar-fill" style={{ width, background: color }}></div>
//                         </div>
//                         <span className="bar-count">{count}</span>
//                       </div>
//                     ))}
//                   </div>

//                   <div className="chart-panel">
//                     <div className="chart-title">
//                       <i className="fa-solid fa-indian-rupee-sign" style={{ color: "var(--primary)", fontSize: ".72rem" }}></i> Salary Expectation (LPA)
//                     </div>
//                     {[
//                       ["Under 8", "9%", "#94a3b8", 13],
//                       ["8–12", "22%", "#6366f1", 32],
//                       ["12–18", "41%", "var(--primary)", 61],
//                       ["18–25", "19%", "var(--amber)", 28],
//                       ["25+", "9%", "var(--green)", 14],
//                     ].map(([label, width, color, count]) => (
//                       <div className="bar-row" key={label}>
//                         <span className="bar-label">{label}</span>
//                         <div className="bar-track">
//                           <div className="bar-fill" style={{ width, background: color }}></div>
//                         </div>
//                         <span className="bar-count">{count}</span>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>

//           {/* Filter bar */}
//           <FilterBar onSubmitFilters={handleFilterSubmit} moreOpen={moreOpen} setMoreOpen={setMoreOpen} />

//           {loading && (
//             <div style={{ textAlign: "center", padding: "1rem", color: "var(--muted)", fontSize: ".82rem" }}>
//               <i className="fa-solid fa-circle-notch fa-spin"></i> Loading candidates…
//             </div>
//           )}

//           {/* Cards view */}
//           {view === "cards" && (
//             <div className="cands-grid">
//               {filteredCandidates.map((c, idx) => (
//                 <CandidateCard
//                   key={c.id || c.name || idx}
//                   c={c}
//                   navigate={navigate}
//                   onOpenNote={(cand) => setNoteFor(cand)}
//                   onOpenFeedback={(cand) => setFeedbackFor(cand)}
//                   onOpenOffer={(cand) => setOfferFor(cand)}
//                   onOpenHire={(cand) => setHireFor(cand)}
//                 />
//               ))}
//             </div>
//           )}

//           {/* Table view */}
//           {view === "table" && (
//             <div className="og-card">
//               <table className="cand-table">
//                 <thead>
//                   <tr>
//                     <th>
//                       <input type="checkbox" style={{ accentColor: "var(--primary)" }} />
//                     </th>
//                     <th>Candidate</th>
//                     <th>Exp</th>
//                     <th>Location</th>
//                     <th>Skills</th>
//                     <th>Current Stage</th>
//                     <th>Last Job · Status</th>
//                     <th>Days</th>
//                     <th>Last Note</th>
//                     <th>Source</th>
//                     <th>Salary</th>
//                     <th>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {filteredCandidates.map((c, idx) => (
//                     <tr key={c.id || c.name || idx}>
//                       <td>
//                         <input type="checkbox" style={{ accentColor: "var(--primary)" }} />
//                       </td>
//                       <td>
//                         <div style={{ fontWeight: 600, cursor: "pointer" }} onClick={() => navigate("recruitment-candidate-profile.html")}>
//                           {c.name}
//                         </div>
//                         <div style={{ fontSize: ".72rem", color: "var(--muted)" }}>{c.email || ""}</div>
//                       </td>
//                       <td>{c.exp}</td>
//                       <td>{c.location}</td>
//                       <td>
//                         {c.skills.slice(0, 2).map((s) => (
//                           <span className="skill-chip" key={s} style={{ marginRight: 3 }}>
//                             {s}
//                           </span>
//                         ))}
//                       </td>
//                       <td>
//                         <span className={`stage-badge ${STAGE_BADGE_CLASS[c.stage] || ""}`}>{c.stage}</span>
//                       </td>
//                       <td>
//                         <div style={{ fontSize: ".78rem", fontWeight: 600 }}>{c.job}</div>
//                         <div
//                           className="cc-int-status"
//                           style={{ background: c.interviewStatus.bg, color: c.interviewStatus.color, display: "inline-block", fontSize: ".68rem", padding: "1px 5px", borderRadius: 3, marginTop: 2 }}
//                         >
//                           {c.interviewStatus.label}
//                         </div>
//                       </td>
//                       <td style={{ fontSize: ".78rem", fontWeight: 600, color: "var(--primary)" }}>{c.activityWhen || c.lastNote?.when || "-"}</td>
//                       <td className="note-cell">{c.lastNote ? c.lastNote.text : "-"}</td>
//                       <td>
//                         <span className={`source-badge ${SOURCE_BADGE_CLASS[c.source] || ""}`}>{c.sourceLabel}</span>
//                       </td>
//                       <td>{c.salary}</td>
//                       <td>
//                         <div style={{ display: "flex", gap: ".3rem" }}>
//                           <button className="btn-ghost btn-xs" onClick={() => navigate("recruitment-candidate-profile.html")}>
//                             <i className="fa-solid fa-eye"></i>
//                           </button>
//                           {c.stage === "Shortlisted" && (
//                             <button className="btn-ghost btn-xs" style={{ color: "var(--green)" }} onClick={() => setOfferFor(c)}>
//                               <i className="fa-solid fa-file-contract"></i>
//                             </button>
//                           )}
//                           {c.stage === "Offer Given" && (
//                             <button className="btn-ghost btn-xs" style={{ color: "var(--green)" }} onClick={() => setHireFor(c)}>
//                               <i className="fa-solid fa-user-check"></i>
//                             </button>
//                           )}
//                           <button className="btn-ghost btn-xs" onClick={() => setNoteFor(c)}>
//                             <i className="fa-solid fa-note-sticky"></i>
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </div>


//       {/* Modals */}
//       <NoteModal candidate={noteFor} onClose={() => setNoteFor(null)} onSaved={(msg) => { setNoteFor(null); showToast(msg); }} />
//       <FeedbackModal candidate={feedbackFor} onClose={() => setFeedbackFor(null)} onSaved={(msg) => { setFeedbackFor(null); showToast(msg); }} />
//       <OfferModal candidate={offerFor} onClose={() => setOfferFor(null)} onSaved={(msg) => { setOfferFor(null); showToast(msg); }} />
//       <HireModal candidate={hireFor} onClose={() => setHireFor(null)} onSaved={(msg) => { setHireFor(null); showToast(msg); }} />

//       <Toast message={toastMsg} onDone={() => setToastMsg("")} />
//     </div>
//   );
// }

import React, { useEffect, useRef, useState } from "react";
import { Formik, Form, Field, ErrorMessage, useFormikContext } from "formik";
import * as Yup from "yup";
import { Paginator } from "primereact/paginator";
import "./CandidatesPage.css";
import { getCandidateList } from "./Service/RecruitmentService";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";

// Add these once in index.js / App.js if not already present:
// import "primereact/resources/themes/lara-light-indigo/theme.css";
// import "primereact/resources/primereact.min.css";

/* ----------------------------------------------------------------------
   Lookups
   Stage IDs 101-104 are confirmed from your data. 105-110 follow the
   StageDistribution order, so verify them against your master table.
---------------------------------------------------------------------- */
const STAGE_ID = {
  Applied: 101,
  Screening: 102,
  Interview: 103,
  Shortlisted: 104,
  Negotiation: 105,
  "Offer Given": 106,
  "Offer Accepted": 107,
  "Offer Rejected": 108,
  Hired: 109,
  Rejected: 110,
};

const STAGE_BADGE_CLASS = {
  Applied: "sb-applied",
  Screening: "sb-screening",
  Interview: "sb-interview",
  Shortlisted: "sb-shortlisted",
  Negotiation: "sb-negotiation",
  "Offer Given": "sb-offer",
  Hired: "sb-hired",
  Rejected: "sb-rejected",
};

const STAGE_CARD_CLASS = {
  Applied: "stage-applied",
  Interview: "stage-interview",
  Shortlisted: "stage-shortlisted",
  "Offer Given": "stage-offer",
  Hired: "stage-hired",
  Rejected: "stage-rejected",
};

const SOURCE_BADGE_CLASS = {
  ATS: "src-ats",
  "ATS / Direct Apply": "src-ats",
  "HR Upload": "src-hr",
  Referral: "src-ref",
  Naukri: "src-naukri",
  LinkedIn: "src-linkedin",
  Indeed: "src-indeed",
};

const STAGE_COLORS = ["#6366f1", "#16a34a", "#d97706", "#7c3aed", "#0891b2", "#9ca3af", "#0ea5e9", "#dc2626"];

const INITIAL_FILTERS = {
  search: "",
  stage: "",
  job: "",
  source: "",
  location: "",
  experienceRangeId: "",
  salaryRangeId: "",
  noticePeriod: "Any",
  currentCompany: "",
  keySkills: "",
  workMode: "",
  recruiter: "Anyone",
  addedAfter: "",
  lastActivity: "Any time",
  hasResume: "Any",
  hasNotes: "Any",
  interviewStatus: "Any",
};

/* ----------------------------------------------------------------------
   Helpers
---------------------------------------------------------------------- */
function initialsOf(name = "") {
  const parts = name.trim().split(/\s+/);
  return ((parts[0]?.[0] || "") + (parts[1]?.[0] || "")).toUpperCase() || "NA";
}

function colorFor(seedText = "") {
  let hash = 0;
  for (let i = 0; i < seedText.length; i++) hash = seedText.charCodeAt(i) + ((hash << 5) - hash);
  return STAGE_COLORS[Math.abs(hash) % STAGE_COLORS.length];
}

function interviewStatusFor(stage) {
  switch (stage) {
    case "Interview":
      return { label: "Interview in progress", bg: "#fff7ed", color: "#c2410c" };
    case "Shortlisted":
      return { label: "Shortlisted", bg: "var(--green-lt)", color: "var(--green)" };
    case "Offer Given":
      return { label: "Offer pending response", bg: "#fef9c3", color: "#854d0e" };
    case "Rejected":
      return { label: "Not cleared", bg: "var(--red-lt)", color: "var(--red)" };
    default:
      return { label: "No interview yet", bg: "var(--gray-lt)", color: "var(--gray)" };
  }
}

/* Maps one item of Data.Candidates to the shape the UI uses */
function normalizeCandidate(item) {
  const name = item.FullName  || "Unknown";
  const stage = item.LastJobStage || "";

  // Skills is an array of objects; some values are "^"-joined ("swiftui^objective c")
  const skills = (item.Skills || [])
    .flatMap((s) => String(s.SkillName || "").split("^"))
    .map((s) => s.trim())
    .filter(Boolean);

  const job = item.LastJobCode
    ? `${item.LastJobCode}${item.LastJobTitle ? " — " + item.LastJobTitle : ""}`
    : "-";

  return {
    id: item.Id,
    name,
    initials: initialsOf(name),
    color: colorFor(name),
    role: [item.CurrentRole, item.CurrentCompany].filter(Boolean).join(" @ ") || "-",
    exp: item.ExperienceRange || "-",
    location: item.Location || "-",
    salary: item.SalaryRange || "-",
    days: item.NoticePeriodDays ? `${item.NoticePeriodDays} days notice` : null,
    source: item.CandidateSource || "-",
    sourceLabel: item.CandidateSource || "-",
    stage,
    skills: skills.length ? skills : ["-"],
    lastNote: item.LastNote
      ? { text: item.LastNote, by: item.LastNoteByName || "", when: item.LastNoteOn?.slice(0, 10) || null }
      : null,
    job,
    interviewStatus: interviewStatusFor(stage),
    activityWhen: item.LastJobId ? `${item.DaysSinceLastActivity}d ago` : null,
    email: item.Email || "",
    phone: item.Phone || "",
  };
}

/* ----------------------------------------------------------------------
   Validation schemas
---------------------------------------------------------------------- */
const filterSchema = Yup.object({
  search: Yup.string(),
  stage: Yup.string(),
  job: Yup.string(),
  source: Yup.string(),
  location: Yup.string(),
  experienceRangeId: Yup.string(),
  salaryRangeId: Yup.string(),
  noticePeriod: Yup.string(),
  currentCompany: Yup.string(),
  keySkills: Yup.string(),
  workMode: Yup.string(),
  recruiter: Yup.string(),
  addedAfter: Yup.string(),
  lastActivity: Yup.string(),
  hasResume: Yup.string(),
  hasNotes: Yup.string(),
  interviewStatus: Yup.string(),
});

const noteSchema = Yup.object({
  note: Yup.string().trim().required("Note is required"),
});

const feedbackSchema = Yup.object({
  technicalRating: Yup.number().min(1, "Please rate technical skills").required("Required"),
  communicationRating: Yup.number().min(1, "Please rate communication").required("Required"),
  recommendation: Yup.string().required("Please pick a recommendation"),
  comments: Yup.string(),
});

const offerSchema = Yup.object({
  job: Yup.string().required("Job is required"),
  offerDate: Yup.date().required("Offer date is required"),
  offerLetter: Yup.mixed().nullable(),
});

const hireSchema = Yup.object({
  joiningDate: Yup.date().required("Joining date is required"),
  department: Yup.string().required("Department is required"),
});

/* ----------------------------------------------------------------------
   Small presentational helpers
---------------------------------------------------------------------- */
function Toast({ message, onDone }) {
  useEffect(() => {
    if (!message) return undefined;
    const t = setTimeout(onDone, 2800);
    return () => clearTimeout(t);
  }, [message, onDone]);
  if (!message) return null;
  return (
    <div className="og-toast">
      <i className="fa-solid fa-check-circle" style={{ color: "#4ade80" }}></i>
      {message}
    </div>
  );
}

function RatingPicker({ value, onChange }) {
  return (
    <div style={{ display: "flex", gap: ".15rem" }}>
      {Array.from({ length: 10 }, (_, i) => i + 1).map((n) => (
        <button
          key={n}
          type="button"
          className={`rating-btn${value >= n ? " active" : ""}`}
          onClick={() => onChange(n)}
        >
          {n}
        </button>
      ))}
    </div>
  );
}

/* ----------------------------------------------------------------------
   Modal: Add Note
---------------------------------------------------------------------- */
function NoteModal({ candidate, onClose, onSaved }) {
  if (!candidate) return null;
  return (
    <div className="modal-overlay open" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal-box">
        <Formik
          initialValues={{ note: "" }}
          validationSchema={noteSchema}
          onSubmit={async (values, { setSubmitting }) => {
            try {
              // await addCandidateNote({ candidateId: candidate.id, note: values.note });
              onSaved("Note added successfully");
            } finally {
              setSubmitting(false);
            }
          }}
        >
          {({ isSubmitting }) => (
            <Form>
              <div className="modal-head">
                <div className="modal-icon" style={{ background: "#fffbeb" }}>
                  <i className="fa-solid fa-note-sticky" style={{ color: "var(--amber)" }}></i>
                </div>
                <div style={{ flex: 1 }}>
                  <div className="modal-title">Add Note</div>
                  <div className="modal-sub">{candidate.name}</div>
                </div>
                <button type="button" className="modal-close-btn" onClick={onClose}>
                  <i className="fa-solid fa-times"></i>
                </button>
              </div>
              <div className="modal-body">
                <div className="fg">
                  <label>
                    Note <span style={{ color: "var(--primary)" }}>*</span>
                  </label>
                  <Field as="textarea" name="note" rows="4" className="og-textarea" placeholder="Add internal note about this candidate…" />
                  <ErrorMessage name="note" component="div" className="fg-error" />
                </div>
              </div>
              <div className="modal-foot">
                <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary btn-sm" disabled={isSubmitting}>
                  <i className="fa-solid fa-check"></i> Save Note
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

/* ----------------------------------------------------------------------
   Modal: Interview Feedback
---------------------------------------------------------------------- */
function FeedbackModal({ candidate, onClose, onSaved }) {
  if (!candidate) return null;
  return (
    <div className="modal-overlay open" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal-box" style={{ maxWidth: 540 }}>
        <Formik
          initialValues={{ technicalRating: 0, communicationRating: 0, recommendation: "Reject", comments: "" }}
          validationSchema={feedbackSchema}
          onSubmit={async (values, { setSubmitting }) => {
            try {
              // await submitInterviewFeedback({ candidateId: candidate.id, ...values });
              onSaved("Feedback submitted");
            } finally {
              setSubmitting(false);
            }
          }}
        >
          {({ values, setFieldValue, isSubmitting }) => (
            <Form>
              <div className="modal-head">
                <div className="modal-icon" style={{ background: "#fffbeb" }}>
                  <i className="fa-solid fa-star" style={{ color: "var(--amber)" }}></i>
                </div>
                <div style={{ flex: 1 }}>
                  <div className="modal-title">Submit Interview Feedback</div>
                  <div className="modal-sub">{candidate.name}</div>
                </div>
                <button type="button" className="modal-close-btn" onClick={onClose}>
                  <i className="fa-solid fa-times"></i>
                </button>
              </div>
              <div className="modal-body">
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: ".75rem", marginBottom: ".75rem" }}>
                  <div>
                    <div style={{ fontSize: ".78rem", fontWeight: 700, marginBottom: ".3rem" }}>Technical Skills</div>
                    <RatingPicker value={values.technicalRating} onChange={(n) => setFieldValue("technicalRating", n)} />
                    <ErrorMessage name="technicalRating" component="div" className="fg-error" />
                  </div>
                  <div>
                    <div style={{ fontSize: ".78rem", fontWeight: 700, marginBottom: ".3rem" }}>Communication</div>
                    <RatingPicker value={values.communicationRating} onChange={(n) => setFieldValue("communicationRating", n)} />
                    <ErrorMessage name="communicationRating" component="div" className="fg-error" />
                  </div>
                </div>
                <div style={{ marginBottom: ".75rem" }}>
                  <div style={{ fontSize: ".78rem", fontWeight: 700, marginBottom: ".3rem" }}>Overall Recommendation</div>
                  <div style={{ display: "flex", gap: ".75rem" }}>
                    {[
                      { value: "Proceed", color: "var(--green)" },
                      { value: "Maybe", color: "var(--amber)" },
                      { value: "Reject", color: "var(--red)" },
                    ].map((opt) => (
                      <label key={opt.value} style={{ display: "flex", alignItems: "center", gap: ".35rem", cursor: "pointer", fontSize: ".85rem" }}>
                        <Field type="radio" name="recommendation" value={opt.value} style={{ accentColor: opt.color }} />
                        <span style={{ color: opt.color, fontWeight: 600 }}>{opt.value}</span>
                      </label>
                    ))}
                  </div>
                  <ErrorMessage name="recommendation" component="div" className="fg-error" />
                </div>
                <Field as="textarea" name="comments" rows="3" className="og-textarea" placeholder="Comments…" />
              </div>
              <div className="modal-foot">
                <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary btn-sm" disabled={isSubmitting}>
                  <i className="fa-solid fa-check"></i> Submit Feedback
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

/* ----------------------------------------------------------------------
   Modal: Give Offer
---------------------------------------------------------------------- */
function OfferModal({ candidate, onClose, onSaved }) {
  if (!candidate) return null;
  return (
    <div className="modal-overlay open" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal-box">
        <Formik
          initialValues={{ job: "JOB-2026-001 — Senior Frontend Developer", offerDate: "", offerLetter: null }}
          validationSchema={offerSchema}
          onSubmit={async (values, { setSubmitting }) => {
            try {
              const formData = new FormData();
              formData.append("job", values.job);
              formData.append("offerDate", values.offerDate);
              if (values.offerLetter) formData.append("offerLetter", values.offerLetter);
              // await sendCandidateOffer(candidate.id, formData);
              onSaved("Offer sent — candidate will be notified via ATS");
            } finally {
              setSubmitting(false);
            }
          }}
        >
          {({ setFieldValue, isSubmitting }) => (
            <Form>
              <div className="modal-head">
                <div className="modal-icon" style={{ background: "#f0fdf4" }}>
                  <i className="fa-solid fa-file-contract" style={{ color: "var(--green)" }}></i>
                </div>
                <div style={{ flex: 1 }}>
                  <div className="modal-title">Give Offer</div>
                  <div className="modal-sub">{candidate.name}</div>
                </div>
                <button type="button" className="modal-close-btn" onClick={onClose}>
                  <i className="fa-solid fa-times"></i>
                </button>
              </div>
              <div className="modal-body">
                <div className="fg">
                  <label>Job</label>
                  <Field as="select" name="job" className="og-select">
                    <option>JOB-2026-001 — Senior Frontend Developer</option>
                  </Field>
                </div>
                <div className="fg">
                  <label>
                    Offer Date <span style={{ color: "var(--primary)" }}>*</span>
                  </label>
                  <Field type="date" name="offerDate" className="og-input" />
                  <ErrorMessage name="offerDate" component="div" className="fg-error" />
                </div>
                <div className="fg">
                  <label>
                    Offer Letter PDF <span style={{ fontSize: ".72rem", fontWeight: 400, color: "var(--muted)" }}>(optional)</span>
                  </label>
                  <input
                    type="file"
                    accept=".pdf"
                    className="og-input"
                    style={{ padding: ".4rem .6rem" }}
                    onChange={(e) => setFieldValue("offerLetter", e.currentTarget.files[0])}
                  />
                </div>
              </div>
              <div className="modal-foot">
                <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary btn-sm" style={{ background: "var(--green)" }} disabled={isSubmitting}>
                  <i className="fa-solid fa-paper-plane"></i> Send Offer
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

/* ----------------------------------------------------------------------
   Modal: Create Employee (Hire)
---------------------------------------------------------------------- */
function HireModal({ candidate, onClose, onSaved }) {
  if (!candidate) return null;
  return (
    <div className="modal-overlay open" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal-box">
        <Formik
          initialValues={{ joiningDate: "", department: "" }}
          validationSchema={hireSchema}
          onSubmit={async (values, { setSubmitting }) => {
            try {
              // await createEmployeeFromCandidate(candidate.id, values);
              onSaved("Employee creation form opened");
            } finally {
              setSubmitting(false);
            }
          }}
        >
          {({ isSubmitting }) => (
            <Form>
              <div className="modal-head">
                <div className="modal-icon" style={{ background: "#dcfce7" }}>
                  <i className="fa-solid fa-user-check" style={{ color: "#14532d" }}></i>
                </div>
                <div style={{ flex: 1 }}>
                  <div className="modal-title">Create Employee Record</div>
                  <div className="modal-sub">{candidate.name}</div>
                </div>
                <button type="button" className="modal-close-btn" onClick={onClose}>
                  <i className="fa-solid fa-times"></i>
                </button>
              </div>
              <div className="modal-body">
                <p style={{ fontSize: ".85rem", color: "var(--muted)", margin: "0 0 .85rem", lineHeight: 1.6 }}>
                  Candidate data will be pre-filled in the employee form. Review and save.
                </p>
                <div className="fg">
                  <label>
                    Joining Date <span style={{ color: "var(--primary)" }}>*</span>
                  </label>
                  <Field type="date" name="joiningDate" className="og-input" />
                  <ErrorMessage name="joiningDate" component="div" className="fg-error" />
                </div>
                <div className="fg">
                  <label>
                    Department <span style={{ color: "var(--primary)" }}>*</span>
                  </label>
                  <Field type="text" name="department" className="og-input" placeholder="Engineering" />
                  <ErrorMessage name="department" component="div" className="fg-error" />
                </div>
              </div>
              <div className="modal-foot">
                <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary btn-sm" style={{ background: "var(--green)" }} disabled={isSubmitting}>
                  <i className="fa-solid fa-user-plus"></i> Create Employee
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

/* ----------------------------------------------------------------------
   Candidate card
---------------------------------------------------------------------- */
function CandidateCard({ c, onOpenNote, onOpenFeedback, onOpenOffer, onOpenHire, navigate }) {
  return (
    <div className={`cand-card-bx ${STAGE_CARD_CLASS[c.stage] || ""}`}>
      <div className="cc-top">
        <div className="cc-av" style={{ background: c.color }}>
          {c.initials}
        </div>
        <div className="cc-info">
          <div className="cc-name" onClick={ () => navigate(`/Recruitment/Candidate-Profile/${c.Guid}`)}>
            {c.name}
          </div>
          <div className="cc-role">
            {c.role} · {c.exp}
          </div>
          <div className="cc-meta">
            <span className="cc-meta-item">
              <i className="fa-solid fa-location-dot" style={{ fontSize: ".62rem" }}></i> {c.location}
            </span>
            <span className="cc-meta-item">
              <i className="fa-solid fa-indian-rupee-sign" style={{ fontSize: ".62rem" }}></i> {c.salary}
            </span>
            {c.days && (
              <span className="cc-meta-item">
                <i className="fa-solid fa-user-clock" style={{ fontSize: ".62rem" }}></i> {c.days}
              </span>
            )}
            <span className={`source-badge ${SOURCE_BADGE_CLASS[c.source] || ""}`}>{c.sourceLabel}</span>
          </div>
        </div>
        {c.stage && (
          <span className={`stage-badge ${STAGE_BADGE_CLASS[c.stage] || ""}`} style={{ alignSelf: "flex-start", flexShrink: 0 }}>
            {c.stage}
          </span>
        )}
      </div>

      <div className="cc-skills">
        {c.skills.map((s, i) => (
          <span className="skill-chip" key={`${s}-${i}`}>
            {s}
          </span>
        ))}
      </div>

      <div className="cc-activity">
        {c.lastNote ? (
          <div className="cc-last-note" style={c.lastNote.warn ? { color: "var(--red)" } : undefined}>
            <strong>{c.lastNote.warn ? "⚠ Feedback pending:" : "Last note:"}</strong> {c.lastNote.text}
            {c.lastNote.by ? ` — ${c.lastNote.by}` : ""}
            {c.lastNote.when ? ` · ${c.lastNote.when}` : ""}
          </div>
        ) : (
          <div className="cc-last-note" style={{ color: "var(--muted)", fontStyle: "normal" }}>
            <i className="fa-solid fa-minus" style={{ fontSize: ".6rem", marginRight: ".25rem" }}></i>No notes yet
          </div>
        )}
        <div className="cc-job-row">
          <i className="fa-solid fa-briefcase" style={{ fontSize: ".62rem", color: "var(--muted)" }}></i>
          <span style={{ color: "var(--text)", fontWeight: 600, fontSize: ".72rem" }}>{c.job}</span>
          <span className="cc-int-status" style={{ background: c.interviewStatus.bg, color: c.interviewStatus.color }}>
            {c.interviewStatus.label}
          </span>
          {c.activityWhen && <span style={{ color: "var(--muted)", fontSize: ".7rem" }}>· {c.activityWhen}</span>}
        </div>
      </div>

      <div className="cc-foot">
        <button className="btn btn-outline btn-xs" onClick={ () => navigate(`/Recruitment/Candidate-Profile/${c.Guid}`)}>
          <i className="fa-solid fa-eye"></i> Profile
        </button>

        {/* Candidate not linked to any job yet */}
        {!c.stage && (
          <>
            <button className="btn btn-primary btn-xs" onClick={() => navigate("recruitment-link-candidate.html")}>
              <i className="fa-solid fa-link"></i> Link Job
            </button>
            <button className="btn-ghost btn-xs" onClick={() => onOpenNote(c)} title="Add note">
              <i className="fa-solid fa-note-sticky"></i>
            </button>
          </>
        )}

        {c.stage === "Applied" && (
          <>
            <button className="btn btn-primary btn-xs" onClick={() => navigate("recruitment-interview-schedule.html")}>
              <i className="fa-solid fa-calendar-plus"></i> Schedule
            </button>
            <button className="btn-ghost btn-xs" onClick={() => navigate("recruitment-link-candidate.html")} title="Link job">
              <i className="fa-solid fa-link"></i>
            </button>
            <button className="btn-ghost btn-xs" onClick={() => onOpenNote(c)} title="Add note">
              <i className="fa-solid fa-note-sticky"></i>
            </button>
          </>
        )}

        {c.stage === "Interview" && !c.lastNote?.warn && (
          <>
            <button className="btn btn-primary btn-xs" onClick={() => navigate("recruitment-link-candidate.html")}>
              <i className="fa-solid fa-link"></i> Link Job
            </button>
            <button className="btn-ghost btn-xs" onClick={() => navigate("recruitment-interview-schedule.html")} title="Schedule interview">
              <i className="fa-solid fa-calendar-plus"></i>
            </button>
            <button className="btn-ghost btn-xs" onClick={() => onOpenNote(c)} title="Add note">
              <i className="fa-solid fa-note-sticky"></i>
            </button>
          </>
        )}

        {c.stage === "Interview" && c.lastNote?.warn && (
          <>
            <button className="btn btn-warn btn-xs" onClick={() => onOpenFeedback(c)}>
              <i className="fa-solid fa-star"></i> Add Feedback
            </button>
            <button className="btn-ghost btn-xs" onClick={() => onOpenNote(c)}>
              <i className="fa-solid fa-note-sticky"></i>
            </button>
          </>
        )}

        {c.stage === "Shortlisted" && (
          <>
            <button className="btn btn-primary btn-xs" onClick={() => onOpenOffer(c)}>
              <i className="fa-solid fa-file-contract"></i> Give Offer
            </button>
            <button className="btn-ghost btn-xs" onClick={() => onOpenNote(c)} title="Add note">
              <i className="fa-solid fa-note-sticky"></i>
            </button>
          </>
        )}

        {c.stage === "Offer Given" && (
          <>
            <button className="btn btn-success btn-xs" onClick={() => onOpenHire(c)}>
              <i className="fa-solid fa-user-check"></i> Create Employee
            </button>
            <button className="btn-ghost btn-xs" onClick={() => onOpenNote(c, true)} title="Send reminder">
              <i className="fa-solid fa-bell"></i>
            </button>
          </>
        )}

        {c.stage === "Rejected" && (
          <button className="btn btn-secondary btn-xs" onClick={() => navigate("recruitment-link-candidate.html")}>
            <i className="fa-solid fa-link"></i> Re-consider
          </button>
        )}
      </div>
    </div>
  );
}

/* ----------------------------------------------------------------------
   Debounced search: submits the form 500ms after the user stops typing
---------------------------------------------------------------------- */
function SearchAutoSubmit({ delay = 500 }) {
  const { values, submitForm } = useFormikContext();
  const first = useRef(true);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      return undefined;
    }
    const t = setTimeout(() => submitForm(), delay);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.search]);

  return null;
}

/* ----------------------------------------------------------------------
   Filter bar (Formik-driven)
---------------------------------------------------------------------- */
function FilterBar({ onSubmitFilters, moreOpen, setMoreOpen }) {
  return (
    <Formik initialValues={INITIAL_FILTERS} validationSchema={filterSchema} onSubmit={(values) => onSubmitFilters(values)}>
      {({ resetForm }) => (
        <Form className="filter-bar">
          <SearchAutoSubmit />

          <div className="filter-row">
            <div className="search-wrap">
              <i className="fa-solid fa-magnifying-glass"></i>
              <Field
                className="search-input"
                name="search"
                placeholder="Search name, email, skills, company, location…"
              />
            </div>

            {/* Sends CandidatureStageId (number) */}
            <Field as="select" className="fs-select" name="stage" onChange={undefined}>
              <option value="">All Stages</option>
              {Object.entries(STAGE_ID).map(([label, id]) => (
                <option key={id} value={id}>
                  {label}
                </option>
              ))}
            </Field>

            {/* Sends JobId (number). Replace with options from your Job List API. */}
            <Field as="select" className="fs-select" name="job">
              <option value="">All Jobs</option>
              <option value="1">JOB-2026-001 — Sr Frontend Dev</option>
              <option value="2">JOB-2026-002 — Product Manager</option>
              <option value="4">JOB-2026-004 — Data Analyst</option>
              <option value="5">JOB-2026-005 — Sr Backend Engineer</option>
            </Field>

            {/* Sends CandidateSourceId (number). Add real IDs for the remaining sources. */}
            <Field as="select" className="fs-select" name="source">
              <option value="">All Sources</option>
              <option value="101">ATS / Direct Apply</option>
              <option value="102">HR Upload</option>
              <option value="108">Consultancy / Vendor</option>
              {/* <option value="?">Referral</option> */}
              {/* <option value="?">Naukri</option> */}
              {/* <option value="?">LinkedIn</option> */}
              {/* <option value="?">Indeed</option> */}
              {/* <option value="?">Walkup</option> */}
            </Field>

            <button type="button" className="btn btn-outline btn-sm" onClick={() => setMoreOpen(!moreOpen)}>
              <i className="fa-solid fa-sliders"></i> {moreOpen ? "Hide Filters" : "More Filters"}
            </button>
            <button
              type="button"
              className="btn-ghost btn-xs"
              title="Clear all filters"
              onClick={() => {
                resetForm();
                onSubmitFilters(INITIAL_FILTERS);
              }}
            >
              <i className="fa-solid fa-xmark"></i> Clear
            </button>
          </div>

          <div className={`more-panel${moreOpen ? " open" : ""}`}>
            <div className="mp-g">
              <label>Location</label>
              <Field className="mp-input" name="location" placeholder="City or Remote" />
            </div>

            {/* API takes ExperienceRangeId. Data uses 101 = 0-1, 102 = 1-3, 103 = 4-7, 104 = 8-12 yrs. */}
            <div className="mp-g">
              <label>Experience Range</label>
              <Field as="select" className="mp-input" name="experienceRangeId">
                <option value="">Any</option>
                <option value="101">0 – 1 years</option>
                <option value="102">1 – 3 years</option>
                <option value="103">4 – 7 years</option>
                <option value="104">8 – 12 years</option>
              </Field>
            </div>

            {/* API takes SalaryRangeId. Data uses 101 = 0-3L, 102 = 3-6L, 103 = 6-10L, 104 = 10-18L. */}
            <div className="mp-g">
              <label>Salary Range (LPA)</label>
              <Field as="select" className="mp-input" name="salaryRangeId">
                <option value="">Any</option>
                <option value="101">₹0L – ₹3L</option>
                <option value="102">₹3L – ₹6L</option>
                <option value="103">₹6L – ₹10L</option>
                <option value="104">₹10L – ₹18L</option>
              </Field>
            </div>

            <div className="mp-g">
              <label>Notice Period</label>
              <Field as="select" className="mp-input" name="noticePeriod">
                <option>Any</option>
                <option>Immediate</option>
                <option>15 days</option>
                <option>30 days</option>
                <option>45 days</option>
                <option>60 days</option>
                <option>90 days</option>
              </Field>
            </div>
            <div className="mp-g">
              <label>Current Company</label>
              <Field className="mp-input" name="currentCompany" placeholder="Company name…" />
            </div>
            <div className="mp-g">
              <label>Key Skills (comma sep.)</label>
              <Field className="mp-input" name="keySkills" placeholder="React, TypeScript…" />
            </div>

            {/* Sends WorkModePreferenceId (number) */}
            <div className="mp-g">
              <label>Work Mode Preference</label>
              <Field as="select" className="mp-input" name="workMode">
                <option value="">Any</option>
                <option value="101">On-site</option>
                <option value="103">Hybrid</option>
                {/* <option value="?">Remote only</option> */}
              </Field>
            </div>
            <div className="mp-g">
              <label>Recruiter</label>
              <Field as="select" className="mp-input" name="recruiter">
                <option>Anyone</option>
                <option>Priya Sharma</option>
                <option>Neha Gupta</option>
                <option>Arun Mishra</option>
              </Field>
            </div>
            <div className="mp-g">
              <label>Added After</label>
              <Field className="mp-input" type="date" name="addedAfter" />
            </div>
            <div className="mp-g">
              <label>Last Activity Within</label>
              <Field as="select" className="mp-input" name="lastActivity">
                <option>Any time</option>
                <option>Last 7 days</option>
                <option>Last 30 days</option>
                <option>Last 90 days</option>
              </Field>
            </div>
            <div className="mp-g">
              <label>Has Resume?</label>
              <Field as="select" className="mp-input" name="hasResume">
                <option>Any</option>
                <option>Yes</option>
                <option>No</option>
              </Field>
            </div>
            <div className="mp-g">
              <label>Has Notes?</label>
              <Field as="select" className="mp-input" name="hasNotes">
                <option>Any</option>
                <option>Has notes</option>
                <option>No notes yet</option>
              </Field>
            </div>
            <div className="mp-g">
              <label>Interview Status</label>
              <Field as="select" className="mp-input" name="interviewStatus">
                <option>Any</option>
                <option>No interview yet</option>
                <option>Interview scheduled</option>
                <option>Feedback pending</option>
                <option>All rounds cleared</option>
              </Field>
            </div>
            <div className="mp-g" style={{ display: "flex", alignItems: "flex-end", gap: ".4rem" }}>
              <button type="submit" className="btn btn-primary btn-sm" style={{ flex: 1, justifyContent: "center" }}>
                Apply
              </button>
              <button type="button" className="btn btn-outline btn-sm" onClick={() => setMoreOpen(false)}>
                Close
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
}

/* ----------------------------------------------------------------------
   Main page
---------------------------------------------------------------------- */
export default function CandidatesPage() {
  const [candidates, setCandidates] = useState([]);
  const [loadError, setLoadError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [view, setView] = useState("cards");
  const [summaryOpen, setSummaryOpen] = useState(true);
  const [moreOpen, setMoreOpen] = useState(false);
  const [toastMsg, setToastMsg] = useState("");
  const [noteFor, setNoteFor] = useState(null);
  const [feedbackFor, setFeedbackFor] = useState(null);
  const [offerFor, setOfferFor] = useState(null);
  const [hireFor, setHireFor] = useState(null);
  const [activeFilters, setActiveFilters] = useState(null);
  const history = useHistory();

  // Pagination (PrimeReact Paginator)
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  // Ignores stale responses when requests overlap (fast typing / quick page changes)
  const requestId = useRef(0);

  const navigate = (path) => {
    history.push(path);
  };

  /* Builds the request payload exactly as the API contract expects */
  const fetchCandidates = async (filters, page = 1, size = rows) => {
    const thisRequest = ++requestId.current;
    setLoading(true);

    const params = {
      CandidateId: 0,
      Guid: "",
      JobId: filters?.job ? Number(filters.job) : 0,
      CandidatureStageId: filters?.stage || "",
      CandidateSourceId: filters?.source || "",
      WorkModePreferenceId: filters?.workMode || "",
      HasResume: filters?.hasResume === "Yes" ? 1 : 0,
      Search: (filters?.search || "").trim(),
      AddedFrom: filters?.addedAfter || "",
      AddedTo: "",
      PageNumber: page,
      PageSize: size,
      SortBy: "CreatedOn",
      SortOrder: "desc",
      ExperienceRangeId: filters?.experienceRangeId || "",
      SalaryRangeId: filters?.salaryRangeId || "",
    };

    try {
      const res = await getCandidateList(params);
      if (thisRequest !== requestId.current) return; // a newer request is in flight

      // Works whether the service returns the body or the axios response
      const data = res?.Data ?? res?.data?.Data;
      const list = data?.Candidates ?? [];

      setCandidates(list.map(normalizeCandidate));
      setTotalRecords(data?.TotalCount ?? 0);
      setLoadError(false);
    } catch (error) {
      if (thisRequest !== requestId.current) return;
      console.error("Failed to load candidates", error);
      setCandidates([]);
      setTotalRecords(0);
      setLoadError(true);
    } finally {
      if (thisRequest === requestId.current) setLoading(false);
    }
  };

  useEffect(() => {
    fetchCandidates(null, 1, rows);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFilterSubmit = (values) => {
    setActiveFilters(values);
    setFirst(0);
    fetchCandidates(values, 1, rows);
  };

  const onPageChange = (e) => {
    setFirst(e.first);
    setRows(e.rows);
    fetchCandidates(activeFilters, e.page + 1, e.rows); // PrimeReact page is 0-based
  };

  const quickFilter = (stageOrActive) => {
    const stage = stageOrActive === "active" ? "" : String(STAGE_ID[stageOrActive] || "");
    handleFilterSubmit({ ...(activeFilters || INITIAL_FILTERS), stage });
  };

  const showToast = (msg) => setToastMsg(msg);

  return (
    <div className="main">
      <div className="topbar">
        <i className="fa-solid fa-user-tie"></i>
        <div className="breadcrumb topbar-breadcrumb">
          <a>Recruitment</a>
          <i className="fa-solid fa-chevron-right"></i>
          <strong className="topbar-current">Candidates</strong>
        </div>
        <div className="top-right">
          <div className="user-mini">
            <div className="top-avatar">AM</div>
            <div>
              <div className="user-name">Arun Mishra</div>
              <div className="user-role">HR Admin</div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid position-relation">
        <div className="Page-head">
          <div className="leftside-head">
            <h2>
              <i className="fa-solid fa-user-tie"></i>
              Candidate Database
            </h2>
            <div className="breadcrumb">Shared candidate pool — one record per person across all jobs</div>
          </div>
          <div className="Left-head-side">
            <div className="view-toggle">
              <button className={`vt-btn${view === "cards" ? " active" : ""}`} onClick={() => setView("cards")}>
                <i className="fa-solid fa-table-cells-large"></i> Cards
              </button>
              <button className={`vt-btn${view === "table" ? " active" : ""}`} onClick={() => setView("table")}>
                <i className="fa-solid fa-table-list"></i> Table
              </button>
            </div>
            <Link to="/Recruitment/Candidate-CVUpload" className="btn btn-outline btn-sm btn-gray">
              <i className="fa-solid fa-cloud-arrow-up"></i> Upload CV
            </Link>
            <Link to="/Recruitment/Recruitment-Candidate-Add" className="btn btn-primary btn-sm">
              <i className="fa-solid fa-user-plus"></i> Add Candidate
            </Link>
          </div>
        </div>

        {/* Stats strip (static numbers; Data.StageDistribution can feed these) */}
        <div className="stat-strip">
          <div className="stat-card sc-total" onClick={() => handleFilterSubmit(null)}>
            <div className="stat-lbl">Total</div>
            <div className="stat-val" style={{ color: "var(--primary)" }}>148</div>
            <div className="stat-sub">In database</div>
          </div>
          <div className="stat-card sc-active" onClick={() => quickFilter("active")}>
            <div className="stat-lbl">Active</div>
            <div className="stat-val" style={{ color: "var(--amber)" }}>62</div>
            <div className="stat-sub">In active pipeline</div>
          </div>
          <div className="stat-card sc-int" onClick={() => quickFilter("Interview")}>
            <div className="stat-lbl">In Interview</div>
            <div className="stat-val" style={{ color: "var(--blue)" }}>19</div>
            <div className="stat-sub">Rounds ongoing</div>
          </div>
          <div className="stat-card sc-hired" onClick={() => quickFilter("Hired")}>
            <div className="stat-lbl">Hired (Q2)</div>
            <div className="stat-val" style={{ color: "var(--green)" }}>8</div>
            <div className="stat-sub">This quarter</div>
          </div>
          <div className="stat-card sc-rej" onClick={() => quickFilter("Rejected")}>
            <div className="stat-lbl">Rejected</div>
            <div className="stat-val" style={{ color: "var(--gray)" }}>78</div>
            <div className="stat-sub">All time</div>
          </div>
        </div>

        {/* Summary section */}
        <div className="summary-section">
          <div className="summary-toggle" onClick={() => setSummaryOpen(!summaryOpen)}>
            <h5>
              <i className="fa-solid fa-chart-pie" style={{ color: "var(--primary)", fontSize: ".82rem" }}></i> Candidate Analytics &amp; Summary
            </h5>
            <div style={{ display: "flex", alignItems: "center", gap: ".75rem" }}>
              <span style={{ fontSize: ".75rem", color: "var(--muted)" }}>148 total across 24 open jobs</span>
              <i
                className="fa-solid fa-chevron-up"
                style={{ fontSize: ".75rem", color: "var(--muted)", transition: "transform .2s", transform: summaryOpen ? "rotate(0deg)" : "rotate(180deg)" }}
              ></i>
            </div>
          </div>

          {summaryOpen && (
            <div className="summary-body">
              <div className="charts-grid">
                <div className="chart-panel">
                  <div className="chart-title">
                    <i className="fa-solid fa-pipe-section" style={{ color: "var(--primary)", fontSize: ".72rem" }}></i> By Pipeline Stage
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                    <svg width="80" height="80" viewBox="0 0 80 80">
                      <circle cx="40" cy="40" r="28" fill="none" stroke="#f3f4f6" strokeWidth="12" />
                      <circle cx="40" cy="40" r="28" fill="none" stroke="#6366f1" strokeWidth="12" strokeDasharray="52.8 123.6" strokeDashoffset="0" transform="rotate(-90 40 40)" />
                      <circle cx="40" cy="40" r="28" fill="none" stroke="var(--amber)" strokeWidth="12" strokeDasharray="37.6 138.8" strokeDashoffset="-52.8" transform="rotate(-90 40 40)" />
                      <circle cx="40" cy="40" r="28" fill="none" stroke="var(--green)" strokeWidth="12" strokeDasharray="25.1 151.3" strokeDashoffset="-90.4" transform="rotate(-90 40 40)" />
                      <circle cx="40" cy="40" r="28" fill="none" stroke="var(--purple)" strokeWidth="12" strokeDasharray="9.4 167" strokeDashoffset="-115.5" transform="rotate(-90 40 40)" />
                      <text x="40" y="37" textAnchor="middle" fontFamily="Onest,Arial" fontSize="12" fontWeight="700" fill="#1e2a3a">148</text>
                      <text x="40" y="50" textAnchor="middle" fontFamily="Onest,Arial" fontSize="7" fill="#8492a6">total</text>
                    </svg>
                    <div style={{ flex: 1 }}>
                      {[
                        ["#6366f1", "Applied", 42],
                        ["var(--amber)", "Interview", 30],
                        ["var(--green)", "Shortlisted", 20],
                        ["var(--purple)", "Offer+", 7],
                        ["var(--gray)", "Rejected", 49],
                      ].map(([color, label, count], idx) => (
                        <div key={label} style={{ display: "flex", justifyContent: "space-between", fontSize: ".72rem", marginBottom: idx < 4 ? 3 : 0 }}>
                          <span style={{ display: "flex", alignItems: "center", gap: ".3rem" }}>
                            <span style={{ width: 8, height: 8, borderRadius: "50%", background: color }}></span>
                            {label}
                          </span>
                          <strong>{count}</strong>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="chart-panel">
                  <div className="chart-title">
                    <i className="fa-solid fa-arrow-pointer" style={{ color: "var(--primary)", fontSize: ".72rem" }}></i> By Source
                  </div>
                  {[
                    ["ATS / Direct", "54%", "#6366f1", 80],
                    ["HR Upload", "25%", "var(--purple)", 37],
                    ["Referral", "11%", "var(--green)", 16],
                    ["Naukri", "7%", "var(--amber)", 10],
                    ["LinkedIn", "3%", "var(--blue)", 5],
                  ].map(([label, width, color, count]) => (
                    <div className="bar-row" key={label}>
                      <span className="bar-label">{label}</span>
                      <div className="bar-track">
                        <div className="bar-fill" style={{ width, background: color }}></div>
                      </div>
                      <span className="bar-count">{count}</span>
                    </div>
                  ))}
                </div>

                <div className="chart-panel">
                  <div className="chart-title">
                    <i className="fa-solid fa-location-dot" style={{ color: "var(--primary)", fontSize: ".72rem" }}></i> By Location
                  </div>
                  {[
                    ["Delhi / NCR", "43%", "var(--primary)", 64],
                    ["Bengaluru", "28%", "#0891b2", 41],
                    ["Mumbai", "11%", "var(--amber)", 16],
                    ["Remote", "9%", "var(--green)", 14],
                    ["Other", "9%", "var(--gray)", 13],
                  ].map(([label, width, color, count]) => (
                    <div className="bar-row" key={label}>
                      <span className="bar-label">{label}</span>
                      <div className="bar-track">
                        <div className="bar-fill" style={{ width, background: color }}></div>
                      </div>
                      <span className="bar-count">{count}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="charts-grid" style={{ borderBottom: "none" }}>
                <div className="chart-panel">
                  <div className="chart-title">
                    <i className="fa-solid fa-briefcase" style={{ color: "var(--primary)", fontSize: ".72rem" }}></i> By Experience Range
                  </div>
                  {[
                    ["0–2 yrs", "15%", "#94a3b8", 22],
                    ["2–4 yrs", "28%", "#6366f1", 42],
                    ["4–6 yrs", "35%", "var(--primary)", 52],
                    ["6–8 yrs", "13%", "var(--amber)", 19],
                    ["8+ yrs", "9%", "var(--green)", 13],
                  ].map(([label, width, color, count]) => (
                    <div className="bar-row" key={label}>
                      <span className="bar-label">{label}</span>
                      <div className="bar-track">
                        <div className="bar-fill" style={{ width, background: color }}></div>
                      </div>
                      <span className="bar-count">{count}</span>
                    </div>
                  ))}
                </div>

                <div className="chart-panel">
                  <div className="chart-title">
                    <i className="fa-solid fa-tags" style={{ color: "var(--primary)", fontSize: ".72rem" }}></i> Top Skills in Database
                  </div>
                  {[
                    ["React", "78%", "#6366f1", 115],
                    ["TypeScript", "65%", "#0891b2", 96],
                    ["Node.js", "42%", "var(--green)", 62],
                    ["Python", "35%", "var(--amber)", 52],
                    ["SQL", "29%", "var(--primary)", 43],
                  ].map(([label, width, color, count]) => (
                    <div className="bar-row" key={label}>
                      <span className="bar-label">{label}</span>
                      <div className="bar-track">
                        <div className="bar-fill" style={{ width, background: color }}></div>
                      </div>
                      <span className="bar-count">{count}</span>
                    </div>
                  ))}
                </div>

                <div className="chart-panel">
                  <div className="chart-title">
                    <i className="fa-solid fa-indian-rupee-sign" style={{ color: "var(--primary)", fontSize: ".72rem" }}></i> Salary Expectation (LPA)
                  </div>
                  {[
                    ["Under 8", "9%", "#94a3b8", 13],
                    ["8–12", "22%", "#6366f1", 32],
                    ["12–18", "41%", "var(--primary)", 61],
                    ["18–25", "19%", "var(--amber)", 28],
                    ["25+", "9%", "var(--green)", 14],
                  ].map(([label, width, color, count]) => (
                    <div className="bar-row" key={label}>
                      <span className="bar-label">{label}</span>
                      <div className="bar-track">
                        <div className="bar-fill" style={{ width, background: color }}></div>
                      </div>
                      <span className="bar-count">{count}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Filter bar */}
        <FilterBar onSubmitFilters={handleFilterSubmit} moreOpen={moreOpen} setMoreOpen={setMoreOpen} />

        {/* Loading / error / empty states (shown for both views) */}
        {loading && (
          <div style={{ textAlign: "center", padding: "1rem", color: "var(--muted)", fontSize: ".82rem" }}>
            <i className="fa-solid fa-circle-notch fa-spin"></i> Loading candidates…
          </div>
        )}
        {!loading && loadError && (
          <div style={{ textAlign: "center", padding: "2rem", color: "var(--red)", fontSize: ".85rem" }}>
            <i className="fa-solid fa-triangle-exclamation"></i> Candidates could not be loaded. Check API/network.
          </div>
        )}
        {!loading && !loadError && candidates.length === 0 && (
          <div style={{ textAlign: "center", padding: "2rem", color: "var(--muted)", fontSize: ".85rem" }}>
            <i className="fa-solid fa-user-slash"></i> Candidate data not found
          </div>
        )}

        {/* Cards view */}
        {!loading && !loadError && view === "cards" && (
          <div className="cands-grid">
            {candidates.map((c, idx) => (
              <CandidateCard
                key={c.id || idx}
                c={c}
                navigate={navigate}
                onOpenNote={(cand) => setNoteFor(cand)}
                onOpenFeedback={(cand) => setFeedbackFor(cand)}
                onOpenOffer={(cand) => setOfferFor(cand)}
                onOpenHire={(cand) => setHireFor(cand)}
              />
            ))}
          </div>
        )}

        {/* Table view */}
        {!loading && !loadError && view === "table" && candidates.length > 0 && (
          <div className="og-card-bx">
            <table className="cand-table">
              <thead>
                <tr>
                  <th>
                    <input type="checkbox" style={{ accentColor: "var(--primary)" }} />
                  </th>
                  <th>Candidate</th>
                  <th>Exp</th>
                  <th>Location</th>
                  <th>Skills</th>
                  <th>Current Stage</th>
                  <th>Last Job · Status</th>
                  <th>Days</th>
                  <th>Last Note</th>
                  <th>Source</th>
                  <th>Salary</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {candidates.map((c, idx) => (
                  <tr key={c.id || idx}>
                    <td>
                      <input type="checkbox" style={{ accentColor: "var(--primary)" }} />
                    </td>
                    <td>
                      <div style={{ fontWeight: 600, cursor: "pointer" }} onClick={ () => history.push(`/Recruitment/Candidate-Profile/${c.Guid}`)}>
                        {c.name}
                      </div>
                      <div style={{ fontSize: ".72rem", color: "var(--muted)" }}>{c.email || ""}</div>
                    </td>
                    <td>{c.exp}</td>
                    <td>{c.location}</td>
                    <td>
                      {c.skills.slice(0, 2).map((s, i) => (
                        <span className="skill-chip" key={`${s}-${i}`} style={{ marginRight: 3 }}>
                          {s}
                        </span>
                      ))}
                    </td>
                    <td>
                      {c.stage ? <span className={`stage-badge ${STAGE_BADGE_CLASS[c.stage] || ""}`}>{c.stage}</span> : "-"}
                    </td>
                    <td>
                      <div style={{ fontSize: ".78rem", fontWeight: 600 }}>{c.job}</div>
                      <div
                        className="cc-int-status"
                        style={{ background: c.interviewStatus.bg, color: c.interviewStatus.color, display: "inline-block", fontSize: ".68rem", padding: "1px 5px", borderRadius: 3, marginTop: 2 }}
                      >
                        {c.interviewStatus.label}
                      </div>
                    </td>
                    <td style={{ fontSize: ".78rem", fontWeight: 600, color: "var(--primary)" }}>{c.activityWhen || c.lastNote?.when || "-"}</td>
                    <td className="note-cell">{c.lastNote ? c.lastNote.text : "-"}</td>
                    <td>
                      <span className={`source-badge ${SOURCE_BADGE_CLASS[c.source] || ""}`}>{c.sourceLabel}</span>
                    </td>
                    <td>{c.salary}</td>
                    <td>
                      <div style={{ display: "flex", gap: ".3rem" }}>
                        <button className="btn-ghost btn-xs" onClick={ () => navigate(`/Recruitment/Candidate-Profile/${c.Guid}`)}>
                          <i className="fa-solid fa-eye"></i>
                        </button>
                        {c.stage === "Shortlisted" && (
                          <button className="btn-ghost btn-xs" style={{ color: "var(--green)" }} onClick={() => setOfferFor(c)}>
                            <i className="fa-solid fa-file-contract"></i>
                          </button>
                        )}
                        {c.stage === "Offer Given" && (
                          <button className="btn-ghost btn-xs" style={{ color: "var(--green)" }} onClick={() => setHireFor(c)}>
                            <i className="fa-solid fa-user-check"></i>
                          </button>
                        )}
                        <button className="btn-ghost btn-xs" onClick={() => setNoteFor(c)}>
                          <i className="fa-solid fa-note-sticky"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Pagination */}
        {totalRecords > 0 && (
          <Paginator
            first={first}
            rows={rows}
            totalRecords={totalRecords}
            rowsPerPageOptions={[10, 25, 50, 100]}
            onPageChange={onPageChange}
          />
        )}
      </div>

      {/* Modals */}
      <NoteModal candidate={noteFor} onClose={() => setNoteFor(null)} onSaved={(msg) => { setNoteFor(null); showToast(msg); }} />
      <FeedbackModal candidate={feedbackFor} onClose={() => setFeedbackFor(null)} onSaved={(msg) => { setFeedbackFor(null); showToast(msg); }} />
      <OfferModal candidate={offerFor} onClose={() => setOfferFor(null)} onSaved={(msg) => { setOfferFor(null); showToast(msg); }} />
      <HireModal candidate={hireFor} onClose={() => setHireFor(null)} onSaved={(msg) => { setHireFor(null); showToast(msg); }} />

      <Toast message={toastMsg} onDone={() => setToastMsg("")} />
    </div>
  );
}